CustomTC.define('jquery/selector',[ "./selector-sizzle" ], function( ) {});

